// Generated by scripts/generate-monster-registry.mjs. Do not edit.
import monster0 from "./alpha-wolf.json" with { type: "json" };
import monster1 from "./ancestral-pack-wolf.json" with { type: "json" };
import monster2 from "./ash-shinobi.json" with { type: "json" };
import monster3 from "./black-forge-master.json" with { type: "json" };
import monster4 from "./black-forge-overseer.json" with { type: "json" };
import monster5 from "./brown-bear.json" with { type: "json" };
import monster6 from "./forge-saboteur.json" with { type: "json" };
import monster7 from "./frontier-deserter-jonin.json" with { type: "json" };
import monster8 from "./renegade-captain.json" with { type: "json" };
import monster9 from "./renegade-marksman.json" with { type: "json" };
import monster10 from "./renegade-miner.json" with { type: "json" };
import monster11 from "./renegade-support-ninja.json" with { type: "json" };
import monster12 from "./renegade-trapper.json" with { type: "json" };
import monster13 from "./slag-golem.json" with { type: "json" };
import monster14 from "./swordsman-bandit.json" with { type: "json" };
import monster15 from "./wolf.json" with { type: "json" };

export const RAW_MONSTER_CONTENT = {
  "alpha_wolf": monster0,
  "ancestral_pack_wolf": monster1,
  "ash_shinobi": monster2,
  "black_forge_master": monster3,
  "black_forge_overseer": monster4,
  "brown-bear": monster5,
  "forge_saboteur": monster6,
  "frontier_deserter_jonin": monster7,
  "renegade_captain": monster8,
  "renegade_marksman": monster9,
  "renegade_miner": monster10,
  "renegade_support_ninja": monster11,
  "renegade_trapper": monster12,
  "slag_golem": monster13,
  "swordsman_bandit": monster14,
  "wolf": monster15,
} as const;

export type MonsterContentId = keyof typeof RAW_MONSTER_CONTENT;
